import React from 'react'
import {PageWrap} from "../../Components";
import VacationCalendar from "../../Containers/Vacation/VacationCalendar";

const VacationCalendarPage = () => (
    <PageWrap>
        <h3>휴가 캘린더</h3>
        <VacationCalendar/>
    </PageWrap>
)

export default VacationCalendarPage
